Array.prototype.flatMap =
  Array.prototype.flatMap ||
  function flatMap(callbackfn) {
    return Array.prototype.concat(...this.map(callbackfn));
  };
